import React from 'react';
import PageHeader from '../PageHeader';

export default ({ i18n, className }) => (
  <div className="centered-content">
    <div className={`notice-window ${className}`}>
      <PageHeader i18nPath={i18n.path()} />

      <p dangerouslySetInnerHTML={{ __html: i18n.t('content') }} />
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/NoticeWindow/index.js